import { auth, storage } from '../config/firebase';
import { ref, uploadBytes, getDownloadURL, list } from 'firebase/storage';
import axios from 'axios';
const baseUrl = 'https://us-central1-theapp-428906.cloudfunctions.net/';
 

  export const uploadAudioFile = async (file) => {
    try {
      const user = auth.currentUser;
      if (!user) {
        throw new Error('Utilisateur non authentifié');
      }
console.log(file);
      // Créer une référence dans Firebase Storage
      const fileRef = ref(storage, `${file.name}`);
      console.log(fileRef);
      // Upload du fichier
      await uploadBytes(fileRef, file);
      
      // Récupération de l'URL
      const url = await getDownloadURL(fileRef);
      console.log(url);
      return url;
    } catch (error) {
      console.error('Erreur lors de l\'upload du fichier:', error);
      throw new Error('Échec de l\'upload du fichier audio: ' + error.message);
    }
  }

  export const getAudioFiles = async () => {
    try {
      const listRef = ref(storage, '');
      const res = await list(listRef);
      
      // Récupérer les URLs et les métadonnées pour chaque fichier
      const filesPromises = res.items.map(async (itemRef) => {
        const url = await getDownloadURL(itemRef);
        return {
          name: itemRef.name,
          url: url,
          path: itemRef.fullPath
        };
      });
      
      const files = await Promise.all(filesPromises);
      return files;
    } catch (error) {
      console.error('Erreur lors de la récupération des fichiers:', error);
      throw new Error('Échec de la récupération des fichiers: ' + error.message);
    }
  };

  export const transcribeAudio = async (audioUrl) => {
    try {
      const response = await axios.post(`${baseUrl}transcribeAudio`, {
        audioUrl: audioUrl
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la transcription:', error);
      throw new Error('Échec de la transcription: ' + error.message);
    }
  };

  // export const processAudioFile = async (file) => {
  //   try {
  //     // Upload vers Firebase Storage
  //     const audioUrl = await uploadAudioFile(file);
  //     console.info(audioUrl);
  //     // Transcription du fichier
  //  //   const transcription = await this.transcribeAudio(audioUrl);
      
  //    // return transcription;
  //   } catch (error) {
  //     console.error('Erreur lors du traitement du fichier:', error);
  //     throw error;
  //   }
  // }
